import { createApp } from 'vue'
import App from './App.vue'
// px to rem
import './utils/lib-flexible'
import 'vant/lib/index.css'
import * as global from './global/lib/index'
import './router/permission'
import router from './router'
import store from './store'
import 'element-plus/dist/index.css'
import './styles/index.scss'
import 'vant/lib/index.css';
// 引入本地 iconfont
import './styles/iconfont/iconfont.css'
import './styles/iconfont/iconfont.js'
import UiForm from '@/components/UI/form/src/form.vue'
import IconSvg from '@/components/UI/iconSvg/index.vue'
import PageHeader from '@/components/PageHeader/index.vue'
import BottomTabBar from '@/components/BottomTabBar/index.vue'

// 微服务架构
// import microApp from '@micro-zoe/micro-app'
// import VueDOMPurifyHTML from 'vue-dompurify-html'

// microApp.start()

const app = createApp(App)
app.use(router)
app.use(store)
// app.use(VueDOMPurifyHTML)
global.install(app)
app.component('IconSvg', IconSvg)
app.component('PageHeader', PageHeader)
app.component('BottomTabBar', BottomTabBar)
app.component('UIForm', UiForm)

app.mount('#app')
